export default {
  label: {
    dashboardSelectlabel: 'Dashboard',
    dashboardSelectPlaceholder: 'Selecione um dashboard',
    noTitleDashboard: 'Dashboard sem título',
    isStagingTooltip: 'Essa pesquisa pertence ao ambiente de teste (staging)',
  },
};
